export default __webpack_public_path__ + "static/SRUS AP100 - Especification Del Producto y Datos Técnicos-05cd01db067bfdf687577bed118fe0c3.pdf";